module.exports = __webpack_public_path__ + "static/media/bg-header-METADATA.195382c0.png";